class FilterTab extends HTMLElement {
  constructor() {
    super();
    this.activeItem = null;
    this.productCache = [];
  }

  connectedCallback() {
    this.cacheProducts();

    this.querySelectorAll(".text-wrapper[data-type]").forEach((item) => {
      item.addEventListener("click", () => this.handleClick(item));
    });

    this.observePagination();
  }

  cacheProducts() {
    this.productCache = Array.from(
      document.querySelectorAll("product-block"),
    ).map((block) => {
      const container = block.closest(".product-block__container");
      return {
        el: container ?? block,
        tags: Array.from(block.classList),
      };
    });
  }

  handleClick(item) {
    if (this.activeItem === item) {
      item.classList.remove("is-active");
      this.activeItem = null;
      this.showAll();
      return;
    }
    this.activeItem?.classList.remove("is-active");
    item.classList.add("is-active");
    this.activeItem = item;
    this.filterCardProduct(item.dataset.type);
  }

  showAll() {
    this.productCache.forEach(({ el }) => {
      el.classList.remove("hidden");
    });
  }

  filterCardProduct(tip) {
    if (!tip) return;

    this.productCache.forEach(({ el, tags }) => {
      el.classList.toggle("hidden", !tags.includes(tip));
    });
  }

  observePagination() {
    // 监听翻页容器的 DOM 变化
    const productContainer = document.querySelector(
      ".product-grid, .collection-grid, main",
    );
    if (!productContainer) return;

    this.observer = new MutationObserver(() => {
      this.cacheProducts();
      if (this.activeItem) {
        this.filterCardProduct(this.activeItem.dataset.type);
      }
    });

    this.observer.observe(productContainer, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define("filter-tab", FilterTab);
